import endsWith from 'lodash/fp/endsWith';
var IMAGE_EXTENSIONS = ['.jpg', '.jpeg', '.png', '.gif', '.bmp'];
export default function isImage() {
  var url = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return IMAGE_EXTENSIONS.some(function (i) {
    return endsWith(i, url.toLowerCase());
  });
}